import ManFigure from "../../assets/figures/manFigure";

export default function Spotlight() {
    return (
        <div>
            <div className="bg-pattern _none pt-6 pb-6 mb-5">
                <div className="container">
                    <div className="layout row layout-builder__layout">
                        <div className="col-12">
                            <div
                                className="_none ixm-blocks-container ixm-spotlight-block pt-5 pb-5">
                                <div className="row">
                                    <div className="col-12 col-lg-8">
                                        <div className="row">
                                            <h2 style={{ fontSize: "clamp(2rem, 8vw, 5rem)", fontWeight: 700 }}>
                                                Extern <span className="brand-color">Spotlight</span>
                                            </h2>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-lg-8">
                                        <div>
                                            <p>
                                                Every cohort, we see students surprise themselves. We often hear parents
                                                say "I wish I could have gone here as a kid". &nbsp;
                                            </p>
                                        </div>
                                    </div>
                                    <div
                                        className="d-none d-lg-block col-lg-1 position-relative ixm-blocks--spotlight-card-arrow">
                                    </div>
                                    <div
                                        className="col-12 col-lg-3 align-self-center cta-button">
                                        <div className="col-auto cta-link my-2">
                                        </div>
                                    </div>
                                </div>
                                <div className="row cards-row">
                                    <div
                                        className="col-12 p-0 col-lg-7 ixm-blocks--spotlight-column ixm-blocks--spotlight-column-size-wide ixm-blocks--spotlight-column-align-left">
                                        <article
                                            className="ixm-blocks--spotlight ixm-blocks--spotlight-card-size-wide ixm-blocks--spotlight-card-align-left position-relative">
                                            <a href="/education/founders"
                                               className="text-decoration-none">

                                                {/* TODO: HOST this image - fix sizing */}
                                                <img className="w-100"
                                                     src="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/editorial/1-yjtns4atga3dvza4jdvzyg.webp"
                                                     alt="The Major Startup Founders in America"/> </a>
                                            <div
                                                className="ixm-blocks--spotlight-card-tag ixm-blocks--spotlight-card-tag-size-wide position-absolute bottom-0 p-3 ms-3">
                                                <a href="/education/founders"
                                                   className="stretched-link text-decoration-none d-flex align-items-center gap-2 fw-bold fs-6">
                                                    Legacy of 100+ years <span
                                                    className="material-icons fs-6 pe-lg-4 me-lg-2 align-middle">arrow_forward</span>
                                                </a>
                                            </div>
                                            <div
                                                className="position-absolute ixm-blocks--spotlight-card-illustration ixm-blocks--spotlight-card-illustration-align-left d-none d-lg-block">
                                            </div>
                                        </article>
                                    </div>
                                    <div
                                        className="col-12 p-0 col-lg-4 offset-lg-1 ixm-blocks--spotlight-column ixm-blocks--spotlight-column-size-slim ixm-blocks--spotlight-column-align-right">
                                        <article
                                            className="ixm-blocks--spotlight ixm-blocks--spotlight-card-size-slim ixm-blocks--spotlight-card-align-right position-relative">
                                            <a href="/stories/next-big-thing"
                                               className="text-decoration-none">
                                                <img className="w-100"
                                                     src="https://firebasestorage.googleapis.com/v0/b/extern-academy.firebasestorage.app/o/website%2Fimages%2Fharvard_girl.webp?alt=media&token=83ea9786-e9b0-414e-aa22-9610def8de9e"
                                                     alt="Extern Academy Co-Founder"/> </a>
                                            <div
                                                className="ixm-blocks--spotlight-card-tag ixm-blocks--spotlight-card-tag-size-slim position-absolute bottom-0 p-3 ms-3">
                                                <a href="/stories/next-big-thing"
                                                   className="stretched-link text-decoration-none d-flex align-items-center gap-2 fw-bold fs-6">
                                                    The Next Big Thing <span
                                                    className="material-icons fs-6 pe-lg-4 me-lg-2 align-middle">arrow_forward</span>
                                                </a>
                                            </div>
                                            <div
                                                className="position-absolute ixm-blocks--spotlight-card-illustration ixm-blocks--spotlight-card-illustration-align-right d-none d-lg-block">
                                            </div>
                                        </article>
                                    </div>
                                    <div
                                        className="col-12 p-0 col-lg-4 ixm-blocks--spotlight-column ixm-blocks--spotlight-column-size-slim ixm-blocks--spotlight-column-align-left">
                                        <article
                                            className="ixm-blocks--spotlight ixm-blocks--spotlight-card-size-slim ixm-blocks--spotlight-card-align-left position-relative">
                                            <a href="/admissions"
                                               className="text-decoration-none">

                                                {/* TODO: Delete this image */}
                                                <img className="w-100"
                                                     src="https://www.saschina.org/sites/default/files/styles/focal_point_spotlight_420x500/public/2024-05/69eab5061d704edb2a60c653c6be7a1b.jpg.webp?itok=2ZYLEaVV"
                                                     alt="Meet a family"/> </a>
                                            <div
                                                className="ixm-blocks--spotlight-card-tag ixm-blocks--spotlight-card-tag-size-slim position-absolute bottom-0 p-3 ms-3">
                                                <a href="/admissions"
                                                   className="stretched-link text-decoration-none d-flex align-items-center gap-2 fw-bold fs-6">
                                                    The Admissions process <span
                                                    className="material-icons fs-6 pe-lg-4 me-lg-2 align-middle">arrow_forward</span>
                                                </a>
                                            </div>
                                            <div
                                                className="position-absolute ixm-blocks--spotlight-card-illustration ixm-blocks--spotlight-card-illustration-align-left d-none d-lg-block">
                                            </div>
                                        </article>
                                    </div>
                                    <div
                                        className="col-12 p-0 col-lg-7 offset-lg-1 ixm-blocks--spotlight-column ixm-blocks--spotlight-column-size-wide ixm-blocks--spotlight-column-align-right">
                                        <article
                                            className="ixm-blocks--spotlight ixm-blocks--spotlight-card-size-wide ixm-blocks--spotlight-card-align-right position-relative">
                                            <a href="/education/trainer"
                                               className="text-decoration-none">
                                                <img className="w-100"
                                                     src="https://firebasestorage.googleapis.com/v0/b/extern-academy.firebasestorage.app/o/website%2Fimages%2F87599a02a5bd5792a99a152bc0955dde.jpg.webp?alt=media&token=3d5d5e36-c3d9-4f1e-9e45-874c13e03ad3"
                                                     alt="Mentor Student Engagement"/>
                                            </a>
                                            <div
                                                className="ixm-blocks--spotlight-card-tag ixm-blocks--spotlight-card-tag-size-wide position-absolute bottom-0 p-3 ms-3">
                                                <a href="/education/trainer"
                                                   className="stretched-link text-decoration-none d-flex align-items-center gap-2 fw-bold fs-6">
                                                    Student Trainer Engagement <span
                                                    className="material-icons fs-6 pe-lg-4 me-lg-2 align-middle">arrow_forward</span>
                                                </a>
                                            </div>

                                            <ManFigure/>
                                        </article>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}